import { render, staticRenderFns } from "./hotSpotPic.vue?vue&type=template&id=46c174e4&scoped=true"
import script from "./hotSpotPic.vue?vue&type=script&lang=js"
export * from "./hotSpotPic.vue?vue&type=script&lang=js"
import style0 from "./hotSpotPic.vue?vue&type=style&index=0&id=46c174e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c174e4",
  null
  
)

export default component.exports